import { render } from "./EditProBookingDialog.vue?vue&type=template&id=4605689a"
import script from "./EditProBookingDialog.vue?vue&type=script&lang=js"
export * from "./EditProBookingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__